import { Alert, AlertBody, AlertIcon, RiAlertLine, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { SecondaryNav } from '@/components';
import { usePathSet } from '@/hooks/usePathSet';
import { usePlotOverview } from '@/hooks/usePlotOverview';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { usePlot } from '@/pages/shared/hooks/usePlot';
import { buildPath } from '@/utils/buildPath';

import { PlotOverviewForm } from './components/PlotOverviewForm';

export const PlotOverviewPage = () => {
  const { t } = useTranslation();

  const menuItems = useMenuItems();
  const plot = usePlot().data;
  const paths = usePathSet();

  const plotOverviews = usePlotOverview(plot.id, 'all').data;

  return (
    <SignedInPageLayout items={menuItems}>
      <SecondaryNav title={plot.name} backPath={buildPath(paths.uploadsPlotOverview)} className='!p-0' />
      <Stack spacing={10} className='mt-4'>
        <span className='typography-h3 text-text-primary'>{t('navbar.plotOverview')}</span>
        {plotOverviews?.length === 0 && (
          <Alert>
            <AlertIcon>
              <RiAlertLine size={24} />
            </AlertIcon>
            <AlertBody>{t('shared.uploadsPlotOverview.plotOverview.labels.noPlotOverview')}</AlertBody>
          </Alert>
        )}
        {plotOverviews.map((overview) => (
          <PlotOverviewForm
            key={overview.id}
            {...overview}
            plotOverviewId={overview.id}
            isApproved={overview?.is_approved}
            mediaFiles={overview.media_files ?? []}
          />
        ))}
      </Stack>
    </SignedInPageLayout>
  );
};
